import React, {FC, useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {Button} from "primereact/button";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {routes} from "../../../app/routes";
import TextInput from "../../../components/form/TextInput";
import {
    useCreateIndustryMutation,
    useFindIndustryByIdQuery,
    useUpdateIndustryMutation
} from "../../../api/eventsStoreApi";
import {
    initialIndustryState,
    selectSettingState, setIndustryProperty,
    setSettingData
} from "../../../slices/settingsSlice";
import {ProgressSpinner} from "primereact/progressspinner";

const UpdateIndustry: FC<{}> = ({}) => {
    const {id = ""} = useParams();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const {isLoading: isPrepareLoading} = useFindIndustryByIdQuery(
        {id: id},
        {skip: id === ""}
    );
    const [
        updateIndustry,
        {isLoading: isUpdateLoading, isSuccess: isUpdateSuccess},
    ] = useUpdateIndustryMutation();
    const [
        createIndustry,
        {isLoading: isCreateLoading, isSuccess: isCreateSuccess},
    ] = useCreateIndustryMutation();

    const {industry} = useAppSelector(selectSettingState);
    const {name} = industry;

    const isSuccess = isUpdateSuccess || isCreateSuccess;

    useEffect(() => {
        dispatch(setSettingData({property: "industry", value: initialIndustryState}));

        if (isSuccess) {
            navigate(`/${routes.SETTINGS}/${routes.INDUSTRIES}`);
        }
    }, [navigate, isSuccess]);

    const onSubmit = () => {
        !!id
            ? updateIndustry({id: id, industryDto: industry})
            : createIndustry({industryDto: industry});
    };

    return (
        <>
            <div className="grid m-5">
                <h3 className="text-center p-1 mt-0">
                    {!id
                        ? `Add industry`
                        : `Update industry ${name}`}
                </h3>
                <TextInput
                    id="name"
                    name="name"
                    value={name}
                    label="Nazwa"
                    setProperty={setIndustryProperty}
                />
                {isCreateLoading || isUpdateLoading ?
                    <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}><ProgressSpinner/>
                    </div> : <Button label="Save" className="mt-5 w-full" onClick={onSubmit}/>}
            </div>
        </>
    );
};

export default UpdateIndustry;
